"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/cms_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSAccountService = void 0;
const cms_service_pb_1 = require("./cms_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.account.v1.CMSAccountService
 */
exports.CMSAccountService = {
    typeName: "spwn.account.v1.CMSAccountService",
    methods: {
        /**
         * @generated from rpc spwn.account.v1.CMSAccountService.GetCreatorByFirestoreId
         */
        getCreatorByFirestoreId: {
            name: "GetCreatorByFirestoreId",
            I: cms_service_pb_1.CMSAccountServiceGetCreatorByFirestoreIdRequest,
            O: cms_service_pb_1.CMSAccountServiceGetCreatorByFirestoreIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.CMSAccountService.GetCreatorByEmail
         */
        getCreatorByEmail: {
            name: "GetCreatorByEmail",
            I: cms_service_pb_1.CMSAccountServiceGetCreatorByEmailRequest,
            O: cms_service_pb_1.CMSAccountServiceGetCreatorByEmailResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.CMSAccountService.GetBrandByFirestoreId
         */
        getBrandByFirestoreId: {
            name: "GetBrandByFirestoreId",
            I: cms_service_pb_1.CMSAccountServiceGetBrandByFirestoreIdRequest,
            O: cms_service_pb_1.CMSAccountServiceGetBrandByFirestoreIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.CMSAccountService.GetTenantByFirestoreId
         */
        getTenantByFirestoreId: {
            name: "GetTenantByFirestoreId",
            I: cms_service_pb_1.CMSAccountServiceGetTenantByFirestoreIdRequest,
            O: cms_service_pb_1.CMSAccountServiceGetTenantByFirestoreIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.CMSAccountService.GetCoreFansByBrandId
         */
        getCoreFansByBrandId: {
            name: "GetCoreFansByBrandId",
            I: cms_service_pb_1.CMSAccountServiceGetCoreFansByBrandIdRequest,
            O: cms_service_pb_1.CMSAccountServiceGetCoreFansByBrandIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.CMSAccountService.GetCoreFansFilterValues
         */
        getCoreFansFilterValues: {
            name: "GetCoreFansFilterValues",
            I: cms_service_pb_1.CMSAccountServiceGetCoreFansFilterValuesRequest,
            O: cms_service_pb_1.CMSAccountServiceGetCoreFansFilterValuesResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.account.v1.CMSAccountService.CreateTenant
         */
        createTenant: {
            name: "CreateTenant",
            I: cms_service_pb_1.CMSAccountServiceCreateTenantRequest,
            O: cms_service_pb_1.CMSAccountServiceCreateTenantResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.Idempotent,
        },
        /**
         * @generated from rpc spwn.account.v1.CMSAccountService.SaveUserMemo
         */
        saveUserMemo: {
            name: "SaveUserMemo",
            I: cms_service_pb_1.CMSAccountServiceSaveUserMemoRequest,
            O: cms_service_pb_1.CMSAccountServiceSaveUserMemoResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.Idempotent,
        },
    }
};
//# sourceMappingURL=cms_service_connect.js.map